import * as React from "react"
import {Box} from "@mui/material"
import {IconSeeker} from "@ui-seeker/core";

import RepricingCreateButton from "./CreateButton"
import RepricingSearchTextField from "./SearchTextField"
import RepricingClearFilters from "./ClearFilters";


export default function RepricingPageWrapperActions() {
    return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: "calc(100vw - 390px)" }}>
        <Box sx={{ borderLeft: "1px solid", borderLeftColor: "divider", pl: 4, width: 600, display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <RepricingSearchTextField />
            <IconSeeker icon="sliders" sx={{ color: 'primary.main' }} />
            <RepricingClearFilters />
        </Box>

        <RepricingCreateButton />
    </Box>
}